// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PlatformWebhooks_DeliveriesQueryInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** GET /platform-webhooks/deliveries?subscription_id= — optional filter by subscription. */
import { registerContract } from './validate'

export interface PlatformWebhooks_DeliveriesQueryInput {
subscription_id?: number
}

registerContract('PlatformWebhooks_DeliveriesQueryInput', {
  subscription_id: { type: 'number',  required: false },
})
